import { URL_PARAMS } from '../generic';

export const googleApis = {
  geoLocationApi: {
    url: `https://www.googleapis.com/geolocation/v1/geolocate?key=${URL_PARAMS.GOOGLE_MAPS_API_KEY}`,
  },
} as const;
